export default __webpack_public_path__ + "static/media/plus-icon.1494f68d.svg";